import { render, staticRenderFns } from "./project-add-rate-fixed.vue?vue&type=template&id=c3f9b0de&scoped=true&"
import script from "./project-add-rate-fixed.vue?vue&type=script&lang=js&"
export * from "./project-add-rate-fixed.vue?vue&type=script&lang=js&"
import style0 from "./project-add-rate-fixed.vue?vue&type=style&index=0&id=c3f9b0de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f9b0de",
  null
  
)

export default component.exports